import React from 'react';
import Image from 'react-bootstrap/Image';
import CloseIcon from '../assets/img/close.svg';
import { getDefaultImage, getPhotoSrc } from '../utils/Util';

interface IModalHeaderProps {
  photoUrl?: string;
  docURLBack?: string | undefined | null;
  toggle: () => void;
  closeOnly?: boolean;
  enlargePhoto?: (photo: any) => void;
}

const ModalHeader: React.FunctionComponent<IModalHeaderProps> = ({
  photoUrl,
  docURLBack,
  toggle,
  closeOnly,
  enlargePhoto,
}) => {
  return (
    <>
      <div className="d-flex flex-row-reverse">
        <Image
          src={CloseIcon}
          alt="close-icon"
          className="close-icon align-self-end"
          onClick={toggle}
        />
      </div>

      {!closeOnly && (
        <div className="d-flex justify-content-center" style={{ gap: '2rem' }}>
          <Image
            src={getPhotoSrc(photoUrl)}
            roundedCircle={enlargePhoto ? false : true}
            width={180}
            height={180}
            className={!enlargePhoto ? 'profile-image-bg' : ''}
            onError={(e) => {
              e.currentTarget.src = getDefaultImage();
            }}
            onClick={() => {
              enlargePhoto && enlargePhoto(photoUrl);
            }}
          />
          {docURLBack && docURLBack.length > 0 && (
            <Image
              src={getPhotoSrc(docURLBack)}
              roundedCircle={enlargePhoto ? false : true}
              width={180}
              height={180}
              className={!enlargePhoto ? 'profile-image-bg' : ''}
              onError={(e) => {
                e.currentTarget.src = getDefaultImage();
              }}
              onClick={() => {
                enlargePhoto && enlargePhoto(docURLBack);
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ModalHeader;
